<template>
  <b-row>
    <b-col cols="12">
      <router-link :to="{ name: 'EXABExternalFormsList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
    </b-col>
    <b-col cols="12">
      <b-card>
        <Form
          @submit="onSendForm($event)"
          :values="item"
          :violations="violations"/>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'Create',
  components: {
    Form
  },
  data () {
    return {
      item: {
        formType: 1,
        title: '',
        description: '',
        allowedDomain: '',
        offerExternalAddress: '',
        smsBefore: 0,
        smsAfter: 0,
        actionForExistingAgreement: 1,
        isExternalOffer: 0,
        active: 1,
        includeCSS: 1,
        includeJS: 1,
        sendEmailAfter: 1,
        mailToOwner: 1,
        mailToOffice: 1,
        customEmail: 1,
        customEmailContent: '',
        afterSignHtml: '',
        signAgreement: 0,
        agreementItemServiceStatus: 0,
        dateFrom: null,
        dateTo: null,
        documentTemplate: undefined,
        addToReservation: 1,
        afterLoaded: '',
        afterPost: '',
        customCss: '',
        version: 2,
        inputAppearance: 1,
        columnFullWidth: 1,
        form: {
          tabs: []
        }
      }
    }
  },
  watch: {
    created (val) {
      if (val && this.$route.name === 'EXABExternalFormsCreate') {
        this.$router.push({ name: 'EXABExternalFormsList' })
      }
    }
  },
  beforeCreate () {
    checkPagePermission('exabagreements', 'EXABExternalFormsCreate')
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapGetters({
      created: 'externalforms/create/created',
      violations: 'externalforms/create/violations',
      isLoading: 'externalforms/create/isLoading'
    })
  },
  methods: {
    onSendForm (item) {
      this.create(item)
    },
    ...mapActions({
      create: 'externalforms/create/create',
      reset: 'externalforms/create/reset'
    })
  }
}
</script>

<style scoped>

</style>
